import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import "./styles/ReportPage.css";
import DownloadReportWindow from "../../components/DownloadReportWindow";
import search from "/assets/icon/Search.svg";

const formatDate = (date) => {
 const options = { day: "2-digit", month: "2-digit", year: "numeric" };
 return new Date(date).toLocaleDateString("en-GB", options);
};

const formatDateTime = (datetime) => {
 if (!datetime) return "N/A";
 const dateOptions = { day: "2-digit", month: "2-digit", year: "numeric" };
 const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: false };
 const date = new Date(datetime);
 return `${date.toLocaleDateString(
   "en-GB",
   dateOptions
 )} ${date.toLocaleTimeString("en-GB", timeOptions)} น.`;
};

function ShowPoleEnergyReport() {
 const [startDate, setStartDate] = useState('');
 const [endDate, setEndDate] = useState('');
 const [searchQuery, setSearchQuery] = useState("");
 const [showDownloadReport, setShowDownloadReport] = useState(false);
 const [weatherData, setWeatherData] = useState([]);
 const [selectedItem, setSelectedItem] = useState(null);
 const [sensorData, setSensorData] = useState([]);

 const handleDateChange = () => {
   if (startDate && endDate) {
     const start = new Date(startDate);
     const end = new Date(endDate);
     
     if (start > end) {
       alert('วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด');
       return;
     }
   }
 };

 const handleSearchChange = (event) => {
   setSearchQuery(event.target.value);
 };

 const handleClearSelection = () => {
   setSearchQuery("");
   setWeatherData([]);
   setSelectedItem(null);
   setSensorData([]);
   setStartDate('');
   setEndDate('');
 };

 const handleDownloadReportClick = () => {
   setShowDownloadReport(true);
 };

 const handleDownloadReportClose = () => {
   setShowDownloadReport(false);
 };

 const fetchWeatherData = useCallback(async () => {
   if (!searchQuery) {
     setWeatherData([]);
     return;
   }
   try {
     const response = await axios.get(
       `${import.meta.env.VITE_API_URL}/api/polesSearch?searchQuery=${searchQuery}`
     );
     console.log("Weather Data:", response.data);
     setWeatherData(response.data);
   } catch (error) {
     console.error("Error fetching data:", error);
   }
 }, [searchQuery]);

 useEffect(() => {
   fetchWeatherData();
 }, [fetchWeatherData]);

 const fetchSensorData = useCallback(async () => {
   if (selectedItem && startDate && endDate) {
     try {
       const response = await axios.get(
         `${import.meta.env.VITE_API_URL}/api/poles/${selectedItem.id}/sensors?startDate=${startDate}&endDate=${endDate}`
       );
       console.log("Sensor Data:", response.data);
       setSensorData(response.data);
     } catch (error) {
       console.error("Error fetching sensor data:", error);
     }
   }
 }, [selectedItem, startDate, endDate]);

 useEffect(() => {
   fetchSensorData();
 }, [fetchSensorData]);

 const handleItemClick = (item) => {
   if (selectedItem && selectedItem.id === item.id) {
     setSelectedItem(null);
     setSearchQuery("");
     setSensorData([]);
   } else {
     setSelectedItem(item);
     setSearchQuery(item.name);
   }
 };

 const createFileName = () => {
   if (!selectedItem || !startDate || !endDate) return "report";
   return `${selectedItem.name}_${startDate}_to_${endDate}`;
 };

 return (
   <div className="containerPage">
     <div className="showWeatherReport">
       <h1>รายงานสถานะการใช้พลังงานเสา</h1>
       <h4 className="downloadReport" onClick={handleDownloadReportClick}>
         ดาวน์โหลดรายงาน
       </h4>
       <p>ดูรายงานระหว่างวันที่</p>
       <div className="sectiondatereport">
         <div className="date-inputs">
           <div className="date-input-group">
             <label>วันที่เริ่มต้น:</label>
             <input
               type="date"
               value={startDate}
               onChange={(e) => {
                 setStartDate(e.target.value);
                 handleDateChange();
               }}
               className="date-input"
             />
           </div>
           
           <div className="date-input-group">
             <label>วันที่สิ้นสุด:</label>
             <input
               type="date"
               value={endDate}
               onChange={(e) => {
                 setEndDate(e.target.value);
                 handleDateChange();
               }}
               className="date-input"
               min={startDate}
             />
           </div>
         </div>
       </div>

       <p>ค้นหารหัสเสา</p>
       <div className="searchbarreport">
         <div className="search-bar">
           <img src={search} alt="search" className="search-user" />
           <input
             type="text"
             placeholder="ค้นหารหัสเสา ชื่อเสา ตำแหน่งติดตั้ง"
             value={searchQuery}
             onChange={handleSearchChange}
           />
           {selectedItem && (
             <button className="clear-button" onClick={handleClearSelection}>
               &times;
             </button>
           )}
         </div>
       </div>

       <div className="searchResults">
         {searchQuery ? (
           weatherData.length > 0 ? (
             <>
               {selectedItem ? (
                 <div
                   className="resultItem"
                   onClick={() => handleItemClick(selectedItem)}
                   style={{ cursor: "pointer", border: "2px solid #2762F8" }}
                 >
                   <p><strong>ชื่อเสา</strong> {selectedItem.name}</p>
                   <p><strong>Location</strong> {selectedItem.location}</p>
                   <p><strong>ประเภทเสา</strong> {selectedItem.pole_type}</p>
                   <p><strong>Latitude</strong> {selectedItem.lat} , {selectedItem.lng}</p>
                   <p><strong>id</strong> {selectedItem.id}</p>
                 </div>
               ) : (
                 weatherData.map((data) => (
                   <div
                     key={data.id}
                     className="resultItem"
                     onClick={() => handleItemClick(data)}
                     style={{ cursor: "pointer" }}
                   >
                     <p><strong>ชื่อเสา</strong> {data.name}</p>
                     <p><strong>Location</strong> {data.location}</p>
                     <p><strong>ประเภทเสา</strong> {data.pole_type}</p>
                     <p><strong>Latitude</strong> {data.lat} , {data.lng}</p>
                   </div>
                 ))
               )}
             </>
           ) : (
             <p>ไม่พบข้อมูล</p>
           )
         ) : (
           <p>กรุณากรอกคำค้นหา</p>
         )}
       </div>
       <hr />

       {selectedItem && (
         <div className="selectedItemDetails">
           <h2>รายละเอียดเสาที่เลือก</h2>
           <p><strong>ชื่อเสา:</strong> {selectedItem.name}</p>
           <p><strong>เวลาเริ่มต้น:</strong> {startDate || "ไม่ได้เลือก"}</p>
           <p><strong>เวลาสิ้นสุด:</strong> {endDate || "ไม่ได้เลือก"}</p>
         </div>
       )}

       {selectedItem && startDate && endDate && (
         sensorData.length > 0 ? (
           <div className="showReportSection">
             <table className="sensorDataTable">
               <thead>
                 <tr>
                   <th>เวลา</th>
                   <th>แรงดันไฟฟ้า (Volt)</th>
                   <th>กระแสไฟฟ้า (Amp)</th>
                   <th>กำลังไฟฟ้า (Watt)</th>
                   <th>สถานะ</th>
                 </tr>
               </thead>
               <tbody>
                 {sensorData.map((data, index) => (
                   <tr key={index}>
                     <td>{formatDateTime(data.created_on)}</td>
                     <td>{data.volt}</td>
                     <td>{data.amp}</td>
                     <td>{data.watt}</td>
                     <td>{data.energy}</td>
                   </tr>
                 ))}
               </tbody>
             </table>
           </div>
         ) : (
           <p>ไม่พบข้อมูล {selectedItem.name} ระหว่างวันที่ {startDate} ถึงวันที่ {endDate}</p>
         )
       )}

       {showDownloadReport && (
         <DownloadReportWindow
           onClose={handleDownloadReportClose}
           jsonData={{
             poleInfo: {
               name: selectedItem?.name,
               location: selectedItem?.location,
               poleType: selectedItem?.pole_type,
               latitude: selectedItem?.lat,
               longitude: selectedItem?.lng,
               id: selectedItem?.id,
             },
             reportInfo: {
               startDate: startDate,
               endDate: endDate,
             },
             sensorData: sensorData.map((data) => ({
               timestamp: formatDateTime(data.created_on),
               volt: data.volt,
               amp: data.amp,
               watt: data.watt,
               energy: data.energy,
             })),
           }}
           fileName={createFileName()}
           routeName="showpoleenergy"
         />
       )}
     </div>
   </div>
 );
}

export default ShowPoleEnergyReport;